var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2218_7360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9259 52.5794C33.0605 52.5794 33.9967 51.1002 36.6555 51.1002C39.3144 51.1002 39.951 52.5233 42.3102 52.5233C44.6695 52.5233 46.1861 50.3138 47.6653 48.1418C49.3131 45.6515 49.9871 43.2173 50.0433 43.105C49.8935 43.0675 45.4372 41.1764 45.4372 35.9149C45.4372 31.3462 48.9573 29.2865 49.1446 29.1367C46.8228 25.6915 43.2839 25.6166 42.329 25.6166C39.7263 25.6166 37.5917 27.2456 36.2436 27.2456C34.8018 27.2456 32.892 25.7102 30.6263 25.7102C26.3198 25.7102 21.957 29.3801 21.957 36.2894C21.957 40.5772 23.586 45.1272 25.5708 48.0669C27.2747 50.5572 28.7726 52.5981 30.9259 52.5981V52.5794ZM36.4121 25.2046C37.9662 25.2046 39.9323 24.1186 41.0932 22.6769C42.1417 21.3662 42.9094 19.5312 42.9094 17.6962C42.9094 17.4528 42.8907 17.1907 42.8345 17.0034C41.0932 17.0783 39.0148 18.2018 37.7603 19.7184C36.7679 20.8793 35.8691 22.6769 35.8691 24.5306C35.8691 24.7927 35.9066 25.0736 35.944 25.1672C36.0563 25.1859 36.2249 25.2046 36.4121 25.2046Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2218_7360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 39.9998,
    height: 39.9999,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePortfolio);
export default __webpack_public_path__ + "static/media/apple_portfolio.780d17fa70b9a011eb1eb8c821e52bac.svg";
export { ForwardRef as ReactComponent };